import "../about.css";
import { CITY } from "../city";

export function renderAbout(app: HTMLElement): void {
  const a = CITY.about;
  app.innerHTML = `
    <main class="about-page">
      <a class="back-link" href="#/">← Back to ${CITY.backToLabel}</a>

      <h1>${a.heading}</h1>

      <p>
        ${a.intro}
      </p>

      <div class="about-section" id="contact">
        <h2>Feedback &amp; Contact</h2>
        <ul class="contact-list">
          <li>
            Email: <a href="mailto:${a.email}">${a.email}</a>
          </li>
          <li>
            Twitter/X:
            <a href="${a.xUrl}" target="_blank" rel="noopener noreferrer">
              ${a.xHandle}
            </a>
          </li>
          <li>
            Bluesky:
            <a href="${a.bskyUrl}" target="_blank" rel="noopener noreferrer">
              ${a.bskyHandle}
            </a>
          </li>
        </ul>
      </div>
    </main>
  `;
}
